var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "content" },
      [
        _c("h2", [
          _vm._v("Olá " + _vm._s(_vm.capitalizeNames(_vm.nomeUsuario)) + ",")
        ]),
        _c("h2", [
          _vm._v("Seja bem vindo(a) ao Módulo de Gestão de Demandas !")
        ]),
        _c("h2", [
          _vm._v(
            "Através deste Módulo, você conseguirá gerenciar suas atividades e realizar seus fluxos de trabalho com total confiança."
          )
        ]),
        _c("el-button", { on: { click: _vm.criarPainel } }, [
          _vm._v("Criar meu primeiro painel")
        ])
      ],
      1
    ),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content" }, [
      _c("img", {
        staticClass: "imagem",
        attrs: { src: require("@/assets/images/bemVindoDemandas.png") }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6590d084", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6590d084","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/demandas/components/BemVindo.vue
// module id = null
// module chunks = 